import {select} from 'd3-selection';

function _tooltip() {
  if(!this.tooltip()) return;
  const field = this.__execs__.field;
  let key = (d) => {
    return {name: 'key', value:d.key};
  }
  let value = (d, text) => {
    let name = select(this).classed('bar') ? field.yBar.field : field.yLine.field;
    return {name, value:text};//d.value[valueField]}
  }
  this.renderTooltip({value, key});
}

export default _tooltip;


// WEBPACK FOOTER //
// ../node_modules/daisy-chart/src/layouts/combo/_tooltip.js